import React, { useEffect, useState } from "react";
import FontIcon from "react-md/lib/FontIcons";
import "../styles/expandableTableAssignedServices.css";
import EventService from "../../../../../service/event/EventService";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import NoRecordsIcon from "../../../../../assets/icons/no-records.png";
import { Button, SelectField } from "react-md";
import filterApplied from "../../../../../assets/icons/filter-applied-icon.svg";
import funnelIcon from "../../../../../assets/icons/funnel.svg";
import goIcon from "../../../../../assets/icons/right_arrow_go_btn.svg";
import {
  TextField,
  MenuItem,
  Menu,
  IconButton,
  Radio,
} from "@material-ui/core";

const ExpandableTableAssignedServices = (props) => {
  const [expandedRowId, setExpandedRowId] = useState(null); // state to track expanded row
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuFor, setMenuFor] = useState({});
  const [tableData, setTableData] = useState(props?.data?.assignedServices);
  const [selectedServiceTypeObjects, setSelectedServiceTypeObjects] = useState(
    []
  );
  const [serviceId, setServiceId] = useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log("props recvd in expandabel table: ", props);
  }, []);

  useEffect(() => {
    setTableData(props?.data?.assignedServices);
    console.log("props recvd in expandabel table: ", props);
  }, [props]);

  const STATUS_MAP = {
    Active: "active",
    Inactive: "inactive",
  };

  const handleRowClick = (id) => {
    setExpandedRowId(expandedRowId === id ? null : id); // toggle expansion
  };
  const handleMoreClick = (event, service) => {
    setAnchorEl(event.currentTarget);
    setMenuFor({ planData: props?.data?.planData, service: service });
  };

  const stringToInt = (str) => {
    const num = parseInt(str, 10); // Convert string to integer with base 10
    return isNaN(num) ? null : num; // Check if conversion failed
  };

  return (
    <div className="table-container-assigned-plans">
      <table className="expandable-table">
        <thead>
          <tr>
            <th>
              Service ID
              <img
                src={
                  (props?.filterObj?.ids?.length ?? 0) > 0
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(2);
                }}
              />
              {openFilter === 2 && (
                <div className="filter-div-assigned-plans-table">
                  <div className="can-be-booked-for-filter">
                    <TextField
                      placeholder="Service ID"
                      type="text"
                      value={serviceId}
                      onChange={(e) => {
                        setServiceId(e.target.value);
                        if (e.target.value == "") {
                          props.setFilterObj((prev) => ({
                            ...prev,
                            ids: [],
                          }));
                        }
                      }}
                    />
                    <img
                      src={goIcon}
                      alt="Go"
                      style={{
                        width: "20px",
                        height: "20px",
                        cursor: "pointer",
                        marginBottom: "-10px",
                      }}
                      onClick={() => {
                        props.setFilterObj((prev) => ({
                          ...prev,
                          ids: [stringToInt(serviceId)],
                        }));
                      }}
                    />
                  </div>
                </div>
              )}
            </th>
            <th>
              Service type
              <img
                src={
                  (props?.filterObj?.serviceTypeIds?.length ?? 0) > 0
                    ? filterApplied
                    : funnelIcon
                }
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(5);
                }}
              />
              {openFilter === 5 && (
                <div className="filter-div-assigned-plans-table">
                  <Autocomplete
                    style={{
                      width: "300px",
                      maxHeight: "200px",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                    multiple
                    id="multiple-limit-acc-name"
                    options={[
                      ...new Set(
                        (props?.data?.allAssignedServicesArray ?? [])
                          .map((option) =>
                            JSON.stringify({
                              // converting to json string so that .filter can work appropriately and new Set can identify unique values b/c objects are reference types and even if they have same values, they will be treated as different by Set and filter)
                              serviceTypeName: option?.serviceTypeName,
                              serviceTypeId: option?.serviceTypeId,
                            })
                          )
                          .filter((obj) =>
                            obj ? JSON.parse(obj)?.serviceTypeId : false
                          )
                      ),
                    ]}
                    getOptionLabel={(option) =>
                      option ? JSON.parse(option)?.serviceTypeName ?? "-" : "-"
                    }
                    value={selectedServiceTypeObjects ?? []}
                    onChange={(e, v) => {
                      if (v) {
                        setSelectedServiceTypeObjects((prev) => v ?? []);
                        props.setFilterObj((prev) => ({
                          ...prev,
                          serviceTypeIds: (v ?? []).map(
                            (e) => JSON.parse(e)?.serviceTypeId
                          ),
                        }));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        onChange={(e, v) => {
                          // handleFetchAccountCodeOpt(e.target.value);
                        }}
                        {...params}
                        placeholder=""
                        className="autocomplete-text-field-class"
                      />
                    )}
                  />
                </div>
              )}
            </th>
            <th>
              Service code
              <img
                src={
                  (props?.filterObj?.nameMatch?.length ?? 0) > 0
                    ? filterApplied
                    : funnelIcon
                }
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(3);
                }}
              />
              {openFilter === 3 && (
                <div className="filter-div-assigned-plans-table">
                  <Autocomplete
                    style={{
                      width: "300px",
                      maxHeight: "200px",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                    multiple
                    id="multiple-limit-acc-name"
                    options={(props?.data?.allAssignedServicesArray ?? [])
                      .map((option) => option?.name ?? "")
                      .filter((name) => name)}
                    getOptionLabel={(option) => option ?? "-"}
                    value={props?.filterObj?.nameMatch ?? []}
                    onChange={(e, v) => {
                      if (v) {
                        props.setFilterObj((prev) => ({
                          ...prev,
                          nameMatch: v ?? [],
                        }));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        onChange={(e, v) => {
                          // handleFetchAccountCodeOpt(e.target.value);
                        }}
                        {...params}
                        placeholder=""
                        className="autocomplete-text-field-class"
                      />
                    )}
                  />
                </div>
              )}
            </th>
            <th>
              Service mode
              <img
                src={
                  (props?.filterObj?.modeNames?.length ?? 0) > 0
                    ? filterApplied
                    : funnelIcon
                }
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(4);
                }}
              />
              {openFilter === 4 && (
                <div className="filter-div-assigned-plans-table">
                  <Autocomplete
                    style={{
                      width: "300px",
                      maxHeight: "200px",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                    multiple
                    id="multiple-limit-acc-name"
                    options={[
                      ...new Set(
                        (
                          (props?.data?.allAssignedServicesArray ?? []).map(
                            (service) => service?.serviceModeDetails ?? []
                          ) ?? [[]]
                        )
                          .flat()
                          .map((mode) => mode?.modeName ?? "")
                          .filter((name) => name)
                      ),
                    ]}
                    getOptionLabel={(option) => option ?? "-"}
                    value={props?.filterObj?.modeNames ?? []}
                    onChange={(e, v) => {
                      if (v) {
                        props.setFilterObj((prev) => ({
                          ...prev,
                          modeNames: v ?? [],
                        }));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        onChange={(e, v) => {
                          // handleFetchAccountCodeOpt(e.target.value);
                        }}
                        {...params}
                        placeholder=""
                        className="autocomplete-text-field-class"
                      />
                    )}
                  />
                </div>
              )}
            </th>
            <th>MRP</th>
            <th>Discounted price</th>
            <th>If sponsored</th>
            <th>Advanced sponsorship rule</th>
            <th>
              Status
              <img
                className="filter-icon-assigned-plans"
                src={props?.filterObj?.status ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(1);
                }}
              />
              {openFilter === 1 && (
                <div className="filter-div-assigned-plans-table">
                  <div className="can-be-booked-for-filter">
                    {Object.entries(STATUS_MAP).map(([key, val]) => (
                      <div>
                        <Radio
                          label={key}
                          checked={props?.filterObj?.status == val}
                          onClick={() => {
                            setOpenBackdrop(false);
                            setOpenFilter(-1);
                            props.setFilterObj((prev) => ({
                              ...prev,
                              status: val,
                            }));
                          }}
                        />
                        <label className="label-radio-btn">{key}</label>
                      </div>
                    ))}
                    <Button
                      className="clear-navigo-booked-for"
                      onClick={() => {
                        props.setFilterObj((prev) => ({
                          ...prev,
                          status: null,
                        }));
                      }}
                    >
                      Clear
                    </Button>
                  </div>
                </div>
              )}
            </th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody className="animated-box">
          {Boolean(tableData?.length == null || tableData?.length <= 0) && (
            <tr>
              <td colSpan={10}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 40,
                  }}
                >
                  <div
                    style={{ textAlign: "center", fontFamily: "Montserrat" }}
                  >
                    No records to show
                  </div>
                  <div style={{ height: "16px" }}></div>
                  <img src={NoRecordsIcon} width={50} height={62} />
                </div>
              </td>
            </tr>
          )}

          {tableData && tableData.length > 0 && (
            <tr>
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td
                colSpan={10}
                align="right"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <Button
                  onClick={() => {
                    props.goToPrevPage();
                  }}
                  disabled={props?.pageNum <= 1 || loading}
                >
                  <FontIcon className="navigo-count-icon">arrow_left</FontIcon>
                </Button>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  Showing&nbsp;
                  <span
                    style={{
                      color: "#ef7c01",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    {(props?.pageNum - 1) * props?.pageSize + 1}&nbsp;
                  </span>
                  <span
                    style={{
                      color: "#ef7c01",
                    }}
                  >
                    -
                  </span>
                  <span
                    style={{
                      color: "#ef7c01",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    &nbsp;
                    {props?.totalCount > props?.pageNum * props?.pageSize
                      ? props?.pageNum * props?.pageSize
                      : props?.totalCount}
                  </span>
                  <span>&nbsp;&nbsp;of&nbsp;</span>
                  <span>{` ${props?.totalCount}`}</span>
                </div>
                <Button
                  onClick={() => {
                    props.goToNextPage();
                  }}
                  disabled={
                    loading ||
                    props?.pageNum * props?.pageSize > props?.totalCount ||
                    (props?.totalCount > props?.pageNum * props?.pageSize
                      ? props?.pageNum * props?.pageSize
                      : props?.totalCount) == props?.totalCount
                  }
                >
                  <FontIcon>arrow_right</FontIcon>
                </Button>
              </td>
              <td />
            </tr>
          )}

          {tableData.map((row, index) => (
            <React.Fragment key={index}>
              <tr
                // onClick={() => handleRowClick(row?.id)}
                className={`${index > 0 ? "table-row-border" : ""}`}
              >
                <td>{row?.id}</td>
                <td>{row?.serviceTypeName}</td>
                <td>{row?.name}</td>
                <td>{row?.serviceModeDetails?.[0]?.modeName}</td>
                <td>{row?.serviceModeDetails?.[0]?.maxPrice}</td>
                {/* <td>
                  {moment(row?.basicDetails?.endDate).format("D MMM YYYY")}
                </td> */}
                <td>{row?.serviceModeDetails?.[0]?.discountedPrice}</td>
                <td>
                  {row?.serviceModeDetails?.[0]?.isAdvanceRuleApplicable
                    ? "Yes"
                    : "No"}
                </td>

                <td
                  onClick={(e) => {
                    if (
                      row?.serviceGroupRuleId &&
                      (row?.serviceGroupRuleStatus === 1 ||
                        row?.serviceGroupRuleStatus === 2)
                    ) {
                      if (props?.data?.planData?.id) {
                        props.setView(7, {
                          mode:
                            row?.serviceGroupRuleStatus === 2
                              ? "view"
                              : "update",
                          accountId: props?.data?.accountId,
                          planId: props.data.planData.id,
                          serviceGroupRuleId: row.serviceGroupRuleId,
                        });
                      } else {
                        EventService.emit("showError", {
                          message: `Unable to get plan id`,
                        });
                      }
                    }
                  }}
                >
                  {Boolean(
                    row?.serviceGroupRuleId &&
                      (row?.serviceGroupRuleStatus === 1 ||
                        row?.serviceGroupRuleStatus === 2)
                  ) ? (
                    <div
                      style={{ cursor: "pointer" }}
                      className={`${
                        row?.serviceGroupRuleStatus === 1
                          ? "adv-sp-rule-status-draft"
                          : row?.serviceGroupRuleStatus === 2
                          ? "adv-sp-rule-status-published"
                          : ""
                      }`}
                      // adv-sp-rule-status-draft
                    >
                      {`${
                        row?.serviceGroupRuleStatus === 1
                          ? "Saved as draft"
                          : row?.serviceGroupRuleStatus === 2
                          ? "Published"
                          : ""
                      }`}
                    </div>
                  ) : (
                    "No"
                  )}
                </td>
                <td>
                  {(() => {
                    const isActive =
                      row?.serviceCategory === 1
                        ? row?.groupServiceStatus
                        : row?.serviceModeDetails?.[0]?.isModeActive == 1;
                    return (
                      <div
                        className={`${
                          isActive
                            ? "navigo-appoint-non-select-status-active"
                            : "navigo-appoint-non-select-status-inactive"
                        }`}
                      >
                        <span>{isActive ? "Active" : "Inactive"}</span>
                      </div>
                    );
                  })()}
                </td>
                <td></td>
                <td>
                  <FontIcon
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleMoreClick(e, row)}
                  >
                    more_vert
                  </FontIcon>
                </td>
              </tr>
              {row?.serviceModeDetails?.slice(1)?.map((roww, index) => (
                <tr key={index} className="table-row-expanded animated-box">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{roww?.modeName}</td>
                  <td>{roww?.maxPrice}</td>
                  <td>{roww?.discountedPrice}</td>
                  <td>{roww?.isAdvanceRuleApplicable ? "Yes" : "No"}</td>
                  <td
                    onClick={(e) => {
                      if (
                        row?.serviceGroupRuleId &&
                        (row?.serviceGroupRuleStatus === 1 ||
                          row?.serviceGroupRuleStatus === 2)
                      ) {
                        if (props?.data?.planData?.id) {
                          props.setView(7, {
                            mode:
                              row?.serviceGroupRuleStatus === 2
                                ? "view"
                                : "update",
                            accountId: props?.data?.accountId,
                            planId: props.data.planData.id,
                            serviceGroupRuleId: row.serviceGroupRuleId,
                          });
                        } else {
                          EventService.emit("showError", {
                            message: `Unable to get plan id`,
                          });
                        }
                      }
                    }}
                  >
                    {Boolean(
                      row?.serviceGroupRuleId &&
                        (row?.serviceGroupRuleStatus === 1 ||
                          row?.serviceGroupRuleStatus === 2)
                    ) ? (
                      <div
                        style={{ cursor: "pointer" }}
                        className={`${
                          row?.serviceGroupRuleStatus === 1
                            ? "adv-sp-rule-status-draft"
                            : row?.serviceGroupRuleStatus === 2
                            ? "adv-sp-rule-status-published"
                            : ""
                        }`}
                        // adv-sp-rule-status-draft
                      >
                        {`${
                          row?.serviceGroupRuleStatus === 1
                            ? "Saved as draft"
                            : row?.serviceGroupRuleStatus === 2
                            ? "Published"
                            : ""
                        }`}
                      </div>
                    ) : (
                      "No"
                    )}
                  </td>
                  <td>
                    <div
                      className={`${
                        roww?.isModeActive
                          ? "navigo-appoint-non-select-status-active"
                          : "navigo-appoint-non-select-status-inactive"
                      }`}
                    >
                      <span>
                        {roww?.isModeActive == 1 ? "Active" : "Inactive"}
                      </span>
                    </div>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      {props?.mode == 1 && (
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => {
            setAnchorEl(null);
            setMenuFor(null);
          }}
        >
          <MenuItem
            onClick={() => {
              if (menuFor?.planData && menuFor?.service) {
                props.setView(4, {
                  mode: "view",
                  accountId: props?.data?.accountId,
                  planId: menuFor?.planData?.id,
                  serviceId: menuFor?.service?.id,
                });
              } else {
                EventService.emit("showError", {
                  message: `Unable to get plan ID or service details`,
                });
              }
            }}
          >
            View service
          </MenuItem>
          <MenuItem
            onClick={() => {
              if (menuFor?.planData && menuFor?.service) {
                props.setView(4, {
                  mode: "update",
                  accountId: props?.data?.accountId,
                  planId: menuFor?.planData?.id,
                  serviceId: menuFor?.service?.id,
                });
              } else {
                EventService.emit("showError", {
                  message: `Unable to get plan ID or service details`,
                });
              }
            }}
          >
            Edit service
          </MenuItem>
          <MenuItem
            onClick={() => {
              if (menuFor?.planData && menuFor?.service) {
                props.setView(4, {
                  mode: "view",
                  editMode: "service-providers",
                  accountId: props?.data?.accountId,
                  planId: menuFor?.planData?.id,
                  serviceId: menuFor?.service?.id,
                });
              } else {
                EventService.emit("showError", {
                  message: `Unable to get plan ID or service details`,
                });
              }
            }}
          >
            Assigned service providers
          </MenuItem>
        </Menu>
      )}
      {openBackdrop && (
        <div
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            width: "100vw",
            height: "100vh",
          }}
          onClick={() => {
            setOpenFilter(-1);
            setOpenBackdrop(false);
          }}
        ></div>
      )}
    </div>
  );
};

export default ExpandableTableAssignedServices;
